import { Reducer } from 'redux/utils/Value'

import actionTypes from './canViewSDoHReportsActionTypes'
import InitialState from './CanViewSDoHReportsInitialState'

export default Reducer({ actionTypes, stateClass: InitialState })